export const CSSBreakpoints = {
  xs: 599,
  sm: 719,
  md: 959,
  lg: 1199,
};
